import { Component, OnInit } from '@angular/core';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-transactions-modal',
  templateUrl: './transactions-modal.component.html',
  styleUrls: ['./transactions-modal.component.scss'],
})
export class TransactionsModalComponent implements OnInit {
  authoringContentData: any;
  showTransactionsModalPopup: boolean = false;
  showSpectrumModelPopup:boolean = false;
  showBIChangePlanModelPopup:boolean = false;
  

  constructor(public manageLineService: ManageLineService,
    public utilsSvc: UtilsService) {
  }

  ngOnInit() {
    this.authoringContentData = this.utilsSvc.getContentDataFromSession();
  }


  onCloseClick() {
    this.manageLineService.close();
  }
}
